import { IFourVariantXP } from '../../indigofair/settings/IFourVariantXP';
import { SettingConst } from '../../types';

/**
 * The acquisition team is doing a new round of logged out homepage redesign
 */
export const LOGGED_OUT_HOMEPAGE_REDESIGN_V2_111924 =
  'LOGGED_OUT_HOMEPAGE_REDESIGN_V2_111924' as SettingConst<
    'LOGGED_OUT_HOMEPAGE_REDESIGN_V2_111924',
    keyof typeof IFourVariantXP.Bucket,
    'RETAILER'
  >;
